import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, videos } from '../../settings';
import { PersonProfile, VideoBg, DelayLink, HoveredImage } from '../../components';

import './Home.scss';

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
      mobile: window.innerWidth < 768 ? true : false,
    };

    this.images = images;
    this.videos = videos;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    // Actions.showMenu();
    // Actions.showHeader();
    // Actions.showFooter();
    Actions.headerHome();
    this.scrollTop();
  }

  componentDidUpdate() {}

  render() {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>{this.texts.title}</title>
        </Helmet>

        <div className="home" ref="home">
          <section className="welcome-area backgraund-home">
            {/* {this.state.mobile == false && <VideoBg source={this.videos.home.banner_azul} />} */}
            <div className="container">
              <div className="row">
                <div className="col-12 topo">
                    <h3>Relatório Anual</h3>
                    <h1>
                      ANBIMA
                      <br />
                      2020
                    </h1>
                </div>
              </div>
            </div>
          </section>

          <section className="default-section gray-section intro-area cards-home">
            <div className="container">
              <div className="row flex-center">
                <div className="col-8 left-0">
                  <Fade>
                    <div className="card card--blue">
                      <div className="card-nosso-ano">
                        <h3 className="blue">Nosso <br className="desktop"/> ano</h3>
                        <p>
                        Confira as principais iniciativas <br className="mobile"/>para desenvolver o mercado 
                        </p>
                        <DelayLink
                          to="/estrategias/nosso-ano"
                          className="button button--aylen button--blue button--border-medium button--size-m button--round-l button--text-thick"
                        >
                          Saiba mais
                        </DelayLink>
                      </div>
                      <div className="nosso-ano-img">
                        <img src={images.home.nosso_ano} />
                      </div>
                    </div>
                  </Fade>
                </div>
                <div className="col-4 left-0">
                  <Fade>
                    <div className="card card--yellow card--mensagens-direita">
                      <div className="mensagens-img">
                        <img src={images.home.img_mensagem_1} className="img_mensagem_1" />
                        <img src={images.home.img_mensagem_2} className="img_mensagem_2" />
                        <img src={images.home.img_mensagem_3} className="img_mensagem_3" />
                        <img src={images.home.img_mensagem_4} className="img_mensagem_4" />
                        <img src={images.home.img_mensagem_5} className="img_mensagem_5" />
                        <img src={images.home.img_mensagem_6} className="img_mensagem_6" />
                        <img src={images.home.img_mensagem_mobile} className="img_mensagem_mobile" />
                      </div>
                      <div className="mensagens-home-descri">
                        <h1>Mensagens</h1>
                        <p>
                        Carlos Ambrósio (presidente) 
                        <br/>
                        e Zeca Doherty 
                        <br/>
                        (superintendente-geral) 
                        <br/>
                        comentam sobre 2020 
                        </p>
                        <DelayLink
                            to="/mensagens/presidencia"
                            className="button button--aylen button--yellow button--border-medium button--size-m button--round-l button--text-thick link"
                          >
                            Ver mais
                          </DelayLink>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="default-section associados-area gradient-green">
          <img src={images.home.bg_instituicoes_mobile} className="bg_instituicoes_mobile" />
            {/* {this.state.mobile == false && <VideoBg source={this.videos.home.banner_verde} />} */}
            <div className="container mobile-absolute">
              <div className="row">
                <div className="col-4"></div>
                <div className="col-8 descri-associados">
                  <Fade>
                    <p>
                      A ANBIMA <br className="br_desk" />
                      é feita por:
                    </p>
                    <br />
                  </Fade>
                  <h2>
                   270 instituições associadas 
                  </h2>

                  <Fade bottom>
                    <DelayLink
                      to="/associados"
                      className="button button--aylen button--blue button--border-medium button--size-m button--round-l button--text-thick btn"
                    >
                      Ver mais
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="default-section gray-section intro-area blocks-area">
            <div className="container ">
              <div className="row flex-center">
                <div className="col-6 flex estrategia">
                  <Fade bottom>
                    <div className="card card--blue col-6">
                      <div className="estrategia-card-padding">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="titulo blue">Estratégia</h2>
                        </div>
                        <div className="card__content__body">
                          <p>
                          Acompanhe os resultados do plano de ação estabelecido para o ano
                          </p>
                          <DelayLink
                            to="/plano-de-acao-2020"
                            className="button button--aylen button--blue button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Ver mais
                          </DelayLink>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 plano_acao estrategia-img">
                      {/* <img src={images.home.plano_acao} className="" /> */}
                    </div>
                  </Fade>
                </div>
                <div className="col-6 flex estrategia">
                  <Fade bottom>
                    <div className="card card--blue col-6">
                      <div className="estrategia-card-padding">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="titulo green">Diretoria</h2>
                        </div>
                        <div className="card__content__body">
                          <p>
                          Veja como é formada nossa Diretoria e suas principais atribuições
                          </p>
                          <DelayLink
                            to="/governanca-corporativa/diretoria"
                            className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Saiba mais
                          </DelayLink>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 plano_acao diretoria-img">
                      {/* <img src={images.home.plano_acao} className="" /> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="linha-do-tempo">
          <img src={images.home.bg_quem_somos_mobile} className="bg_quem_somos_mobile" />
            <div className="container">
              <div className="fundo"></div>
              <div className="descri">
                <h1>Quem Somos</h1>
                <p>
                Reunimos bancos, gestoras, corretoras, distribuidoras e administradoras. São instituições
                 de diferentes portes e segmentos, que refletem a pluralidade do mercado.
                </p>
                <DelayLink
                to="/quem-somos"
                className="button button--aylen button--white button--border-medium button--size-m button--round-l button--text-thick"
                >
                  Saiba mais
                </DelayLink>
              </div>
            </div>
          </section>

          <section className="default-section gray-section intro-area cards-home cards-home-footer card-home-eventos ">
            <div className="container">
              <div className="row flex-center">
                <div className="col-8 height-auto">
                  <Fade>
                    <div className="card card--green card-half eventos">
                      <div className="eventos-descri">
                        <h3 className="green">Eventos</h3>
                        <p>
                        Transmissões online garantiram a realização de debates 
                        sobre assuntos de interesse do mercado. 
                        </p>
                        <DelayLink
                          to="/eventos"
                          className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
                        >
                          Saiba mais
                        </DelayLink>
                      </div>
                      <div className="eventos-img">
                        <img src={images.home.eventos_fundo_desk} className="eventos_fundo_desk"/>
                        <img src={images.home.eventos_fundo_mobile} className="eventos_fundo_mobile"/>
                        <img src={images.home.eventos_fundo_verde} className="eventos_fundo_verde"/>
                        <img src={images.home.eventos_pessoa1} className="eventos_pessoa1"/>
                        <img src={images.home.eventos_pessoa2} className="eventos_pessoa2"/>
                        <img src={images.home.eventos_pessoa3} className="eventos_pessoa3"/>
                        <img src={images.home.eventos_pessoa4} className="eventos_pessoa4"/>
                      </div>
                    </div>
                  </Fade>
                </div>
                <div className="col-4 left-0">
                  <Fade>
                    <div className="pessoas">
                      <div className="pessoas-title">
                        <h2 className="blue">Pessoas</h2>
                        <p>
                        Em ano de pandemia, o desafio foi manter o engajamento e a conexão apesar do distanciamento físico. 
                        </p>
                        <DelayLink
                          to="/pessoas"
                          className="button button--aylen button--blue button--border-medium button--size-m button--round-l button--text-thick"
                        >
                          Saiba mais
                        </DelayLink>
                      </div>
                      <div className="pessoas-img">
                        <img src={images.home.pessoas_mobile} className="pessoas_mobile"/>
                        <img src={images.home.pessoas_moldura} className="pessoas_moldura"/>
                        <img src={images.home.pessoas_braco} className="pessoas_braco"/>
                        <img src={images.home.pessoa_pessoa2} className="pessoa_pessoa2"/>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { Home };
